<app-sidebar></app-sidebar>

<div style="position: relative; left: 10px; top: 10px;">
  <div>
    <a (click)="deleteAccess()">تسجيل الخروج</a>
  </div>
</div>

<div *ngFor="let info of about;" style="padding-top: 100px;">
    <div class="md-form">
                  
        <textarea type="text" id="description" class="md-textarea form-control cc2" (focus)="onFocus()" [(ngModel)]="info.description" name='description' mdbInput required></textarea>
    
        <label for="description" class="label">About Us </label>
    
      </div>

      <div class="md-form">
                  
        <textarea type="text" id="description_ar" class="md-textarea form-control cc2" (focus)="onFocus()" [(ngModel)]="info.description_ar" name='description_ar' mdbInput required></textarea>
    
        <label for="description_ar" class="label" style="left: 75%;">عنا </label>
    
      </div>

      <button type="submit" class="btn btn-primary waves-light submit-btn" [disabled]="submit == false"
                     (click)="editAboutUs(info.id,info.description,info.description_ar)">
                        أدخال
    </button>
    <div *ngIf="loading == true">
        <img src="assets/imgs/loading2.gif" class="process">
      </div>
      <div *ngIf="done == true">
        <img src="assets/imgs/done.png" class="process">
      </div>
</div>